module.exports = __webpack_public_path__ + "media/images/icons/flags/IQ-0cc1d3deb350dcc072ed23898f544173.svg";